import { AfterViewInit, Component, Input } from '@angular/core';
import { BehaviorSubject, iif, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { CustomerService } from '../../../shared';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatTableModule } from '@angular/material/table';
import { HlCurrencyPipe } from 'src/app/shared/pipes/hl-currency.pipe';
import { LocationNameFromIdPipe } from 'src/app/shared/pipes/location-name-from-id.pipe';
import { UserIdToNamePipe } from 'src/app/shared/pipes/user-id-to-name.pipe';
import { MomentModule } from 'ngx-moment';

export interface CustomerSalesHistoryItem {
  parent: string;
  parent_id: number;
  parent_type: 'workshopJob' | 'docket' | 'saleDocket';
  line_item_description: string;
  quantity: number;
  unit_price: number;
  line_sub_total: number;
  line_total: number;
  tax_amount: number;
  created_at: string;
  created_by: number;
  location_id: number;
}

@Component({
  selector: 'app-sales-history',
  templateUrl: './sales-history.component.html',
  imports: [
    CommonModule,
    RouterModule,
    MatTableModule,
    HlCurrencyPipe,
    LocationNameFromIdPipe,
    UserIdToNamePipe,
    MomentModule
  ],
  standalone: true
})
export class SalesHistoryComponent implements AfterViewInit {
  @Input() set customerId(value: number) {
    this.currentCustomer.next(value);
  }

  private currentCustomer = new BehaviorSubject<number | null>(null);

  rows$ = this.currentCustomer.pipe(
    switchMap((customerId) =>
      iif(
        () => Boolean(customerId),
        this.customerService.getSalesHistory(customerId),
        of([])
      )
    )
  );

  columns = [
    'parent',
    'line_item_description',
    'quantity',
    'unit_price',
    'total_price',
    'tax_amount',
    'created_by_at',
    'location'
  ];

  constructor(private customerService: CustomerService) {}

  ngAfterViewInit(): void {
    this.currentCustomer.next(this.currentCustomer.value);
  }
}
